// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

import { RequestState }                                  from '@core/interfaces/api.interface';
import { IArchivingProceduralDocumentationEntityEvents } from '@core/interfaces/entity.interface';

export class ArchivingProceduralDocumentationTMO {
	id?: string = undefined;
	businessPremisesId?: string = undefined;
	name?: string = undefined;
	validFrom?: Date = undefined;
	validTo?: Date = undefined;
	retentionFrom?: Date = undefined;
	userDocumentationVersion?: ArchivingProceduralDocumentationVersion = undefined;
	documentationVersion?: ArchivingProceduralDocumentationVersion = undefined;
	lockedDate?: Date = undefined;
	originDocumentationId?: string = undefined;
	status?: ArchivingProceduralDocumentationStatusEnum = undefined;
	created?: Date = undefined;
	lastModified?: Date = undefined;
	replacementId?: string = undefined;
	createdBy?: string = undefined;
	lastModifiedBy?: string = undefined;
}

export class ArchivingProceduralDocumentationVersionTMO {
	proceduralDocument?: string = undefined;
	otherApplicableDocuments?: string = undefined;
}

export class ArchivingProceduralDocumentationRequestTMO {
	name: string = undefined;
	validFrom?: string = undefined;
	replaceId?: string = undefined;
	userDocumentationVersion?: ArchivingProceduralDocumentationVersion = undefined;
}

export class ArchivingProceduralDocumentationUpdateRequestTMO {
	id?: string = undefined;
	name?: string = undefined;
	validFrom?: string = undefined;
	userDocumentationVersion?: ArchivingProceduralDocumentationVersion = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingProceduralDocumentation extends ArchivingProceduralDocumentationTMO {
	ui: IArchivingProceduralDocumentationEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}

export class ArchivingProceduralDocumentationVersion extends ArchivingProceduralDocumentationVersionTMO {
}

export class ArchivingProceduralDocumentationRequest extends ArchivingProceduralDocumentationRequestTMO {
}

export class ArchivingProceduralDocumentationUpdateRequest extends ArchivingProceduralDocumentationUpdateRequestTMO {
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface ProcessConditionals {
	importInProgress?: boolean;

	deletableItemsExist?: boolean;

	readyForImport?: boolean;

	hideErrors?: boolean;

	showLoader?: boolean;

	disableValidFromField?: boolean;
}

// FAILURE
export interface IArchivingProceduralDocumentationImportFailure {
	code: string;

	identifier: string;

	message: string;
}

// ENUMS #############################################################
// API enums *********************************************************

export enum ArchivingProceduralDocumentationStatusEnum {
	OPEN = 'open',
	LOCKED = 'locked',
	REPLACED = 'replaced',
	BEING_REPLACED = 'beingReplaced'
}
// UI enums *********************************************************
